import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const ArrowRight: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M12.29 5.29a1 1 0 0 1 1.42 0l6 6a1 1 0 0 1 0 1.42l-6 6a1 1 0 0 1-1.42-1.42l4.3-4.29H5a1 1 0 0 1 0-2h11.59l-4.3-4.29a1 1 0 0 1 0-1.42Z" />
  </Icon>
);

export default ArrowRight;
